import { formatNewsDate } from "../../../utils/news";

function NewsTab({ news, onAdd, onEdit, onDelete }) {
    return (
        <div className="admin__section">
            <button className="admin__add-btn" onClick={onAdd}>
                + Adauga noutate
            </button>

            <table className="admin__table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Titlu</th>
                        <th>Publicata</th>
                        <th>Data</th>
                        <th>Ordine</th>
                        <th>Actiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {news.length > 0 ? (
                        news.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.title}</td>
                                <td>{parseInt(item.is_published || 0) === 1 ? "Da" : "Nu"}</td>
                                <td>{formatNewsDate(item.published_at)}</td>
                                <td>{item.sort_order}</td>
                                <td>
                                    <button onClick={() => onEdit(item)}>Editeaza</button>
                                    <button className="delete" onClick={() => onDelete(item.id)}>
                                        Sterge
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                                Nu sunt noutati adaugate.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default NewsTab;
